import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/app/contacts-list/components/ContactsListContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c0e7967d947e00146843ba/showcrm/src/components/Sidebar.tsx");
